export default __webpack_public_path__ + "static/bookshelve2-c5e5a08528bd949bab345a5afee2228e.svg";